module.exports = __webpack_public_path__ + "static/media/otb-logo-hero.de22d66d.png";